export default class UserSession {
  constructor({
    accessToken,
    refreshTtl
  } = {}) {
    if (!accessToken) {
      throw new Error('Access Token must be present.');
    }
    if (!refreshTtl) {
      throw new Error('Refresh TTL must be present.');
    }
    this.accessToken = accessToken;
    this.refreshTtl = refreshTtl;
  }

  /**
   * @returns {AccessToken} the session's access token
   */
  getAccessToken() {
    return this.accessToken;
  }

  /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time
   * @returns {boolean} if the session is still valid
   */
  isValid() {
    const now = Math.floor(new Date() / 1000);
    return now < this.accessToken.getExpiration();
  }
  canRefresh() {
    const now = Math.floor(new Date() / 1000);
    const tokenExpiry = this.accessToken.getExpiration();
    const refreshUntil = tokenExpiry + this.refreshTtl;
    return now < refreshUntil;
  }
}